module.exports = __webpack_public_path__ + "static/media/Абдразакова Л., Гильманов А..c867a6e9.pdf";